<template>

	<section :class="{ 'outer-pad': outerPad, 'not-child': true, 'filter-wrap' : true }">

		<div class="update-buttons desktop">

			<span 
				:class="{'large-button': true, 'top-right': true, 'floated': true}"
				v-if="showUpdate || showUpdateButton" 
				@click="update"
			>
				Update graph
			</span>

			<span
				:class="{'large-button': true, 'top-right': true, 'floated': true, selected: average}" 
				@click="average = !average"
				v-if="showCombineButton"
			>
				Average
			</span>

		</div>

		<div class="actions-wrap">

			<div class="zoom-wrap">

				<span
					:class="{ zoom: true, current: zoom.max === 100 }"
					v-html="'Full view'"
					@click="zoom.max=100; zoomChange()"
				/>

				<span
					:class="{ zoom: true, current: zoom.max === 50 }"
					v-html="'50'"
					@click="zoom.max=50; zoomChange()"
				/>

				<span
					:class="{ zoom: true, current: zoom.max === 20 }"
					v-html="'20'"
					@click="zoom.max=20; zoomChange()"
				/>

				<span
					:class="{ zoom: true, current: zoom.max === 10 }"
					v-html="'10'"
					@click="zoom.max=10; zoomChange()"
				/>

				<h3 class="label">Zoom</h3>

			</div>

			<div class="frequency-wrap" v-if="showFilterWeekly||showFilterMonthly">

				<span
					:class="{ frequency: true, current: frequency === 'months' }"
					v-html="'Monthly'"
					@click="frequency='months'; triggerChange()"
					v-if="showFilterMonthly"
				/>

				<span
					:class="{ frequency: true, current: frequency === 'weeks' }"
					v-html="'Weekly'"
					@click="frequency='weeks'; triggerChange()"
					v-if="showFilterWeekly"
				/>

				<span
					:class="{ frequency: true, current: frequency === 'days' }"
					v-html="'Daily'"
					@click="frequency='days'; triggerChange()"
				/>

				<h3 class="label">Frequency</h3>

			</div>

		</div>

		<DateFilter
			@change="changeDate"
			@clear="changeDate"
			:value="dateFilterValues"
		/>

		<div class="extra-filter-wrap">
			<slot></slot>
		</div>

		<div class="update-buttons mobile">
 
			<span 
				:class="{'large-button': true, 'top-right': true, 'floated': true}"
				v-if="showUpdate || showUpdateButton" 
				@click="update"
			>
				Update graph
			</span> 

			<span
				:class="{'large-button': true, 'top-right': true, 'floated': true, selected: average}" 
				@click="average = !average"
				v-if="showCombineButton"
			>
				Average
			</span>

		</div>

	</section>

</template>

<script>
import DateFilter from './Data/DateFilter.vue'
export default {
	name: 'FilterWrap',
	components: { DateFilter },
	props: {
		currentFrequency: {
			type: String,
			default: 'days'
		},
		outerPad: {
			type: Boolean,
			default: true
		},
		showUpdateButton: {
			type: Boolean,
			default: false
		},
		showCombineButton: {
			type: Boolean,
			default: false
		},
		filters: {
			type: Object
		},
		showFilterWeekly: {
			type: Boolean,
			default: false
		},
		showFilterMonthly: {
			type: Boolean,
			default: false
		}
	},
	data() {

		return {
			startDate: null,
			endDate: null,
			frequency: this.currentFrequency,
			showUpdate: false,
			average: false,
			zoom: {
				min: 1,
				max: 100
			}
		}

	},
	watch: {
		startDate: {
			handler (newValue, oldValue) {

				if ( newValue !== oldValue ) {

					this.triggerChange ();

				}

			}
		},
		endDate: {
			handler (newValue, oldValue) {

				if ( newValue !== oldValue ) {

					this.triggerChange ();

				}

			}
		},
		frequency: {
			handler (newValue, oldValue) {

				if ( newValue !== oldValue ) {

					this.triggerChange ();

				}

			}
		},
		filters: {
			handler (newValue, oldValue) {

				this.frequency = this.filters.frequency;

				this.startDate = this.filters.startDate;

				this.endDate = this.filters.endDate;

			},
			deep: true
		},
		currentFrequency: {
			handler (newValue, oldValue) {

				if ( newValue !== oldValue ) {

					this.frequency = newValue;

				}

			}
		},
		average: {
			handler (newValue, oldValue) {

				if ( newValue !== oldValue ) {

					this.triggerChange ();

				}

			}
		}
	},
	computed: {

		dateFilterValues () {

			if ( this.filters && this.filters.startDate && this.filters.endDate ) {

				return { start: this.filters.startDate, end: this.filters.endDate };

			}

			return '';

		}

	},

	methods: {

		changeDate (info) {

			this.startDate = info ? info.start : null;
			this.endDate = info ? info.end : null;

		},

		triggerChange () {

			this.showUpdate = true;

		},
		zoomChange () {
			
			this.$emit( 'zoomChange', this.zoom );

		},

		update () {

			this.showUpdate = false;

			let info = {};

			['startDate','endDate','frequency','average'].forEach( function (t) {

				info[t] = this[t];

			}.bind(this));

			this.$emit( 'change', info );

		}

	},
	created() {

		

	}
}
</script>
<style lang="less" scoped>
@import './../assets/css/less/_helper.less';
@import './../assets/css/less/_settings.less';
@media print {
	.filter-wrap {
		display: none;
	}
}
@media screen {
	.filter-wrap {
		.clearfix;
		position: relative;
		.zoom-wrap, .frequency-wrap {

			float: left;
			width: 100%;
			margin-bottom: 10px;

		}
		.frequency, .date-filter {
			float: right;
		}
		.date-filter {
			margin-bottom: 10px;
			width: 100%;
			max-width: 210px;
		}
		.label {

			display: inline-block;
			font-weight: normal;
			font-size: 12px;
			float: right;
			margin: 9px 0 0 10px;

		}
		.frequency, .zoom {
			background-color: white;
			color: @darkContrast;
			display: block;
			float: right;
			.rounded(4px);
			font-size: 16px;
			padding: 6px 10px 5px;
			cursor: pointer;
			margin-left: 10px;
			&:hover, &.current {
				background-color: @darkContrast;
				color:#fff;
			}
		}
		.actions-wrap {
			float: left;
			width: 100%;
			margin-top: 10px;
			margin-bottom: 10px;
		}
		.extra-filter-wrap {
			float: right;
			margin-top: 3px;
			min-width: 200px;
			width: 100%;
		}
		.large-button {
			margin-left: 10px;
			margin-top: 4px;
			&.selected {
				background-color: @formDefaultColour;
			}
		}
		.update-buttons {
			float: right;
			width: 100%;
			&.desktop {
				display: none;
			}
			&.mobile {
				margin-top: 10px;
			}
		}
	}
}
@media screen and (min-width: 550px) {
	.filter-wrap {

		.actions-wrap {

			float: right;
			margin: 5px 0 0;

			.zoom-wrap, .frequency-wrap {

				width: auto;
				float: right;

			}

		}

		.extra-filter-wrap, .date-filter {

			float: right;
			width: 49%;
			margin-top: 0;
			margin-bottom: 0;

		}

		.date-filter {

			float: right;

		}

	}
}
@media screen and (min-width: 1024px) and (max-width: 1279px) {

	.filter-wrap {

		&.keyword-graph {

			.actions-wrap {

				float: right;
				width: auto;
				margin: 1px 0 0;

				.zoom-wrap, .frequency-wrap {

					width: auto;
					float: right;
					margin-bottom: 0;

				}

			}

			.extra-filter-wrap, .date-filter {

				float: right;
				width: 210px;
				margin-left: 10px;
				margin-bottom: 0;
				max-width:none;

			}

			.date-filter {

				margin-right: 20px;

			}

			.extra-filter-wrap {

				margin-left: 0;

			}

			.update-buttons {
				width: auto;
				&.desktop {
					display: block;
					.large-button {
						margin-left: 10px;
					}

				}
				&.mobile {
					display: none;
				}
			}

			.frequency, .zoom {

				margin-left: 5px;

			}

		}

	}

}

@media screen and (min-width: 1280px) {
	.filter-wrap {

		.actions-wrap {

			float: right;
			width: auto;
			margin: 1px 0 0;

			.zoom-wrap, .frequency-wrap {

				width: auto;
				float: right;
				margin-bottom: 0;

			}

		}

		.extra-filter-wrap, .date-filter {

			float: right;
			width: 220px;
			margin-left: 10px;
			margin-bottom: 0;
			max-width:none;

		}

		.date-filter {

			margin-right: 20px;

		}

		.extra-filter-wrap {

			margin-left: 0;

		}

		.update-buttons {
			width: auto;
			&.desktop {
				display: block;
				.large-button {
						margin-left: 10px;
					}
			}
			&.mobile {
				display: none;
			}
		}

	}
}
</style>